/**
 * Text Field Type - Common
 *
 * Field-type configuration shared by the inline (inline/text.tsx) and
 * modal (modal/text.tsx) renderers.
 */

import type { FieldTypeConfig } from '../../components/types';
import { L } from './columnWidths';

// ============================================================================
// Field Type Configuration
// ============================================================================

/**
 * Text field type configuration
 */
export const textFieldType: FieldTypeConfig = {
  placeholder: (label: string) => `Enter ${label.toLowerCase()}...`,
  ...L,
};
